import * as React from 'react'
import { Button } from '../../shared/'
import './product-back-button.scss'

interface IProps {
  onClick?: Function
}

export class ProductBackButton extends React.PureComponent<IProps> {
  /**
   * This function uses history.back() if the referrer is collections to preserve the user's scroll state
   * Otherwise if the referrer is not collections, just navigate to collections reguarly
   */
  goBack = (): void => {
    if (this.props.onClick) {
      this.props.onClick()
    } else {
      if (document.referrer.includes('/collections/all')) {
        window.history.back()
      } else {
        window.location.href = '/collections/all'
      }
    }
  }

  render(): JSX.Element {
    return (
      <Button
        style="pill"
        display="slim"
        iconLeft="arrow-left-thin"
        onClick={this.goBack}
        class="product-back-button"
      >
        Back to menu
      </Button>
    )
  }
}
